import { useCallback } from 'react';
import { env } from '@/env';
import { useRegistration } from '@/context/RegistrationContext';

export const wregAppLink = (email: string): string => {
  const promoCode = env.ACCESS_PILOT_PROMO_CODE;
  const emailParam = email ? `&email=${encodeURIComponent(email)}` : '';
  return `${env.BRANCH_URL}/?promoCode=${promoCode}${emailParam}`;
};

export const useWregAppLink = (): (() => string) => {
  const { registrationData } = useRegistration();
  const email = registrationData.account.email;
  return useCallback(() => wregAppLink(email), [email]);
};
